module.exports = __webpack_public_path__ + "img/box-skins-null.2c65bde2.jpg";